import { Divider, ListItem } from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";

import assignedToMe from "../../styles/svg/assignedToMe.svg";
import assignedToTeam from "../../styles/svg/assignedToTeam.svg";
import worklogIcon from "../../styles/svg/worklogIcon.svg";
import "./myTask.scss";
import watchingIcon from "../../styles/svg/watching-icon.svg";
import { useMyTaskNavigation } from "./hooks/useMyTaskNavigation";

function MyTask() {
  const { navItems, handleNavClick } = useMyTaskNavigation();

  return (
    <>
      {navItems.map((item) => {
        const icon =
          item.key === "mine-tab"
            ? assignedToMe
            : item.key === "watching-tab"
            ? watchingIcon
            : item.key === "team-tab"
            ? assignedToTeam
            : worklogIcon;

        return (
          <React.Fragment key={item.key}>
            <ListItem className="menu-ListItem my-task-page" onClick={handleNavClick}>
              <NavLink
                to={item.to}
                className={({ isPending }) =>
                  item.isActive ? "active" : isPending ? "pending" : ""
                }
              >
                <img
                  src={icon}
                  alt="not found"
                  className="side-bar-icon"
                />
                <p className="my-task-name-text">{item.label}</p>
              </NavLink>
            </ListItem>
            {item.key !== "worklog-tab" && <Divider />}
          </React.Fragment>
        );
      })}
    </>
  );
}

export default MyTask;
